import "./Footer.css";
import { Link } from "react-router-dom";

import { Logo_Instagram } from "../../assets";
import { Logo_TikTok } from "../../assets";
import { Logo_LinkedIn } from "../../assets";

const Footer = () => {
  return (
    <div className="footer">
      <div className="column-container">
        <p>
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/3d48c.png"}
            alt="48C"
            width="200"
            height="100"
          />
        </p>

        <p>
          <div className="menu">
            <Link to="../epfl/"> Home </Link>
            <a href="../epfl/team"> Team </a>
            <Link to="../epfl/description"> Project </Link>
            <a href="../epfl/results"> Results </a>
          </div>
        </p>

        <p>
          <div className="head"> Follow us: </div>
          <div className="social">
            <a href="https://www.instagram.com/igem_epfl/">
              <img
                src={Logo_Instagram}
                alt="Logo Instagram, if you click on it, you will arrive on the page Instagram"
                width="50"
                height="auto"
              />
            </a>
            <a href="https://www.tiktok.com/@epfl_igem">
              <img
                src={Logo_TikTok}
                alt="Logo TikTok, if you click on it, you will arrive on the page TikTok"
                width="50"
                height="auto"
              />{" "}
            </a>
            <a href="https://ch.linkedin.com/company/igem-epfl-team">
              <img
                src={Logo_LinkedIn}
                alt="Logo LinkedIn, if you click on it, you will arrive on the page LinkedIn"
                width="50"
                height="auto"
              />
            </a>
          </div>

          <div className="head" style={{ textAlign: "start" }}>
            <a href="mailto:epfl.igem@gmail.com">Email us here</a>
          </div>
        </p>
      </div>

      <hr style={{ color: "var(--purple-white)", opacity: "0.4" }} />
      <p style={{ color: "var(--purple-white)" }}>
        <small>
          © 2023 - Content on this site is licensed under a{" "}
          <a href="https://creativecommons.org/licenses/by/4.0/" rel="license">
            Creative Commons Attribution 4.0 International license
          </a>
          .
        </small>
      </p>
      <p style={{ color: "var(--purple-white)" }}>
        <small>
          The repository used to create this website is available at{" "}
          <a href="https://gitlab.igem.org/2023/epfl">
            gitlab.igem.org/2023/epfl
          </a>
          .
        </small>
      </p>
    </div>
  );
};

export default Footer;
